export const dummyCardCulture = {
  error: false,
  data: {
    list: [
      {
        authorId: 6164720,
        authorName: "ka4ka",
        blogId: 6309712,
        blogTitle: "투자철학자",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/6309712/attach/491390091eed4294bb64120a876d3a59",
        blogUrl: "https://ka4ka.today",
        entryThumbnail:
          "https://t1.daumcdn.net/tistory_admin/static/images/top-default-thumbnail.png",
        entryId: 69,
        entryTitle: "[영화이야기] 에어 (2023)",
        entryUrl: "https://ka4ka.today/69",
        entrySummary:
          "나는 선수 생활을 하는 동안 통산 9,000개 이상의 슛을 실패했고, 거의 300 게임을 졌다. 또 모두들 내가 결승골을 넣을 것으로 믿었지만, 그러지 못해 진 것만도 26번이나 된다. 내 삶에서 실패는 늘 반복되었다. 하지만 바로 그런 실패들이 나를 성공으로 이끌었다. 마이클 조던나이키, 조던을 잡아라마이클 가족들 오늘 여기 나이키를 찾아주셔서 감사합니다. 이제부터 왜 저희와 조던이 광고 모델 계약을 맺어야 하는지 보여 드리겠습니다. 이 영상을 보시겠습니다. 불 끄세요. (열심히 영상을 보던 중 나이키 스카우터 담당 '소니 바카로'가 영상 중지 요청을 한다.) 미안한데 영상을 꺼 주세요. 우리가 만든 에어 조던 농구화를 잠시 잊어주세요. 돈도 상관없어요. 어차피 조던 정도면 많은 돈을 벌테니까. 전설이..",
        serviceCategoryName: "영화",
        reactionCount: 256,
        commentCount: 205,
        entryPublished: "2024-03-21T03:47:08+09:00",
        firstReactionCreated: "2024-06-11T15:24:09.856231+09:00",
        isSupportBlog: true,
        supportCount: 6,
        supporters: [
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
        ],
      },
      {
        authorId: 4833775,
        authorName: "띵스띵스",
        blogId: 4647542,
        blogTitle: "오늘의 이슈 / 정보",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/4647542/attach/827104db80774607ab55296eff15ac46",
        blogUrl: "https://ddingstory.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/bH1I4f/btsHUh59WaF/bkNbGulY6tZ4qPGZICbGxk/img.jpg",
        entryId: 826,
        entryTitle:
          '엑소 첸백시 측 "SM, 부당한 요구…긴급 기자회견서 고발할 것"',
        entryUrl:
          "https://ddingstory.tistory.com/entry/%EC%97%91%EC%86%8C-%EC%B2%B8%EB%B0%B1%EC%8B%9C-%EC%B8%A1-SM-%EB%B6%80%EB%8B%B9%ED%95%9C-%EC%9A%94%EA%B5%AC%E2%80%A6%EA%B8%B4%EA%B8%89-%EA%B8%B0%EC%9E%90%ED%9A%8C%EA%B2%AC%EC%84%9C-%EA%B3%A0%EB%B0%9C%ED%95%A0-%EA%B2%83",
        entrySummary:
          '그룹 엑소 첸백시 소속사 IBN100이 SM엔터테인먼트가 부당한 요구를 하고 있다며 긴급 기자회견을 열겠다고 밝혔다. 이어 "당시 양측은 엑소가 정상적으로 활동하는 것이 무엇보다 중요하다는 생각에 협상을 통해 사태를 해결했으며 당시의 합의에 따라 아티스트 개인 명의 및 엑소 첸백시로서의 활동은 INB100을 설립했다. https://im.newspic.kr/f4nj2AN',
        serviceCategoryName: "스타",
        reactionCount: 31,
        commentCount: 19,
        entryPublished: "2024-06-10T15:23:14+09:00",
        firstReactionCreated: "2024-06-11T15:24:09.866047+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
      {
        authorId: 3735867,
        authorName: "우브로",
        blogId: 3864744,
        blogTitle: "매일매일 이슈이야기 - 이슈태그",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/3864744/attach/8f7828e70e0a4e849b902d45e5515c8e",
        blogUrl: "https://issuetag.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/mg9ra/btsHRNempR3/HKUtmrazG2yMwpzYOpF7YK/img.png",
        entryId: 280,
        entryTitle: "[배우] 놀아주는 여자 배우 엄태구 프로필 MBTI 알아보기",
        entryUrl: "https://issuetag.tistory.com/280",
        entrySummary:
          "배우 엄태구는  2024년 JTBC 수목 드라마 '비밀은 없어' 후속작 '놀아주는 여자'에 출연합니다.배우 엄태구는  드라마 '놀아주는 여자'에서 어두운 과거를 청산한 큰형님으로 서지환 역으로 출연해  배우 한선화, 권율이 함께 출연합니다.카리스마 있는 외모와 허스키한 목소리때문에  강한 인상의 배역을 자주 맡았던 엄태구는 이번 드라마에서 로맨스 연기를 보여주며 새로운 연기도전을 보여준다고 합니다.오늘은 놀아주는 여자로 돌아 온 배우 엄태구에 대해 알아보겠습니다.    프로필출생 : 1983년 11월 9일 (40세) 서울특별시 국적 : 대한민국 신체 : 181cm, 70kg, B형 가족 : 부모님, 형 엄태화(1981년생) 학력 : 공군항공과학고등학교 (퇴교)[3]            고등학교 졸업학력 ..",
        serviceCategoryName: "스타",
        reactionCount: 30,
        commentCount: 16,
        entryPublished: "2024-06-10T20:44:36+09:00",
        firstReactionCreated: "2024-06-11T15:24:09.870867+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
    ],
    category: "culture",
    hasNext: false,
  },
};

export const dummyItemCulture = {
  error: false,
  data: {
    lastPublished: 1718070521000,
    list: [
      {
        uniqueId: "6789380_219",
        title:
          "선재 업고 튀어 부산 롯데백화점 센텀시티점 팝업스토어 CJ온스타일 굿즈 온라인 판매",
        summary:
          "선재 업고 튀어    얼마 전 종영한 tvN 월화드라마 '선재 업고 튀어'의 인기에 힘입어 부산 롯데백화점 센텀시티점 지하 2층 분수대 광장에서 '선재 업고 튀어' 팝업스토어가 운영되었습니다.일시: 2024.6.5.(수)~6.12.(수)월~목 10:30~20:00금~토 10:30~20:30* 6월 10일 백화점 정기휴무일에도 팝업스토어 매장은 정상 운영합니다.장소: 부산 롯데백화점 센텀시..",
        userId: 6504063,
        userName: "맬러키",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6789380/attach/7d3c2785d5044c3aa1733351fbfdb483",
        categoryName: "스타",
        thumbnail:
          "https://k.kakaocdn.net/dn/b1eu0R/btsHTVJngDe/k1WHTHBDTjyXp4wkrQRXZk/img.jpg",
        link: "https://hassam01.tistory.com/219",
        blogId: 6789380,
        blogTitle: "매일매일 럭키데이",
        likeCount: 5,
        commentCount: 6,
        firstReactionCreated: 1718085432000,
        published: "2024.06.11 14:56",
        publishedAgo: "30분 전",
        supportCount: 0,
        encodedTitle:
          "%EC%84%A0%EC%9E%AC%20%EC%97%85%EA%B3%A0%20%ED%8A%80%EC%96%B4%20%EB%B6%80%EC%82%B0%20%EB%A1%AF%EB%8D%B0%EB%B0%B1%ED%99%94%EC%A0%90%20%EC%84%BC%ED%85%80%EC%8B%9C%ED%8B%B0%EC%A0%90%20%ED%8C%9D%EC%97%85%EC%8A%A4%ED%86%A0%EC%96%B4%20CJ%EC%98%A8%EC%8A%A4%ED%83%80%EC%9D%BC%20%EA%B5%BF%EC%A6%88%20%EC%98%A8%EB%9D%BC%EC%9D%B8%20%ED%8C%90%EB%A7%A4",
        encodedUserName: "%EB%A7%AC%EB%9F%AC%ED%82%A4",
      },
      {
        uniqueId: "5320393_98",
        title: "240609 샤네마 건대입구 무대인사",
        summary: "",
        userId: 224322,
        userName: "Luire.",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5320393/attach/aa869a816d8a4a528514b4d6e9d67c1e",
        categoryName: "스타",
        thumbnail:
          "https://k.kakaocdn.net/dn/b4dT1s/btsHUyNKfj6/lwPdPjfUenEuJ6qzBObAcK/img.jpg",
        link: "https://luire-xia.tistory.com/98",
        blogId: 5320393,
        blogTitle:
          "\uD835\uDC18\uD835\uDC28\uD835\uDC2E \uD835\uDC2C\uD835\uDC21\uD835\uDC22\uD835\uDC27\uD835\uDC1E \uD835\uDC1F\uD835\uDC28\uD835\uDC2B\uD835\uDC1E\uD835\uDC2F\uD835\uDC1E\uD835\uDC2B ✨",
        likeCount: 5,
        commentCount: 0,
        firstReactionCreated: 1718082074000,
        published: "2024.06.11 00:46",
        publishedAgo: "오늘",
        supportCount: 0,
        encodedTitle:
          "240609%20%EC%83%A4%EB%84%A4%EB%A7%88%20%EA%B1%B4%EB%8C%80%EC%9E%85%EA%B5%AC%20%EB%AC%B4%EB%8C%80%EC%9D%B8%EC%82%AC",
        encodedUserName: "Luire.",
      },
      {
        uniqueId: "3707109_868",
        title: "동물이 고객님! 영화 ‘북극백화점의 안내원’",
        summary:
          "멸종위기종 비롯 다양한 동물 캐릭터 다채로운 비주얼이 담긴 그림들 북극백화점의 안내원(2024)_이타즈 요시미 영화는 귀엽고 소박하지만 다채로운 디자인과 색감의 그림체를 가진다. 그 그림을 감상하는 것만으로도 상영시간을 즐겁게 보내기에 충분한 애니메이션이다. 원작은 일본의 만화 ‘북극 백화점의 컨시어지 씨’. 이때 ‘컨시어지’는 신입 안내원 아..",
        userId: 4243932,
        userName: "문여는곰.",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3707109/attach/c9f488f48fc049b0aae06cdf8bb1c406",
        categoryName: "영화",
        thumbnail:
          "https://k.kakaocdn.net/dn/QbrEV/btsHU7ChYxH/aGwg88L9OY1Ct9mfhZgX4K/img.jpg",
        link: "https://jyshine24.tistory.com/868",
        blogId: 3707109,
        blogTitle: "문여는곰 문화탐방",
        likeCount: 8,
        commentCount: 5,
        firstReactionCreated: 1718081078000,
        published: "2024.06.11 13:33",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%8F%99%EB%AC%BC%EC%9D%B4%20%EA%B3%A0%EA%B0%9D%EB%8B%98%21%20%EC%98%81%ED%99%94%20%E2%80%98%EB%B6%81%EA%B7%B9%EB%B0%B1%ED%99%94%EC%A0%90%EC%9D%98%20%EC%95%88%EB%82%B4%EC%9B%90%E2%80%99",
        encodedUserName: "%EB%AC%B8%EC%97%AC%EB%8A%94%EA%B3%B0.",
      },
      {
        uniqueId: "171194_1286",
        title: "SKY 캐슬, 일본 리메이크는 성공할 수 있을까?",
        summary:
          "JTBC 드라마 'SKY 캐슬'이 일본에서 리메이크된다는 소식이 전해졌습니다. 제작사 SLL은 'SKY 캐슬'의 일본 리메이크판이 주연 배우 캐스팅을 확정하고 촬영에 들어갔다고 11일 밝혔습니다. 이번 리메이크는 일본 민영 방송사 TV 아사히에서 제작을 맡고 있으며, 7월 중에 방송될 예정입니다. 관전 포인트\uD83C\uDFAC 리메이크 결정: 'SKY 캐슬'이 일본에서 리메이크..",
        userId: 139589,
        userName: "-어떤오후-",
        userImage:
          "https://tistory1.daumcdn.net/tistory/171194/attach/51f2c7b4bdc6417b928fa9f47e5ad3e4",
        categoryName: "TV",
        thumbnail:
          "https://k.kakaocdn.net/dn/lm1Dx/btsHTIKrwUq/UNV7fSDzYfrqpdCLp9tr70/img.jpg",
        link: "https://bakong.tistory.com/1286",
        blogId: 171194,
        blogTitle: "어떤오후의 어떤사전 - 뉴스야 놀자",
        likeCount: 10,
        commentCount: 6,
        firstReactionCreated: 1718080451000,
        published: "2024.06.11 13:33",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "SKY%20%EC%BA%90%EC%8A%AC%2C%20%EC%9D%BC%EB%B3%B8%20%EB%A6%AC%EB%A9%94%EC%9D%B4%ED%81%AC%EB%8A%94%20%EC%84%B1%EA%B3%B5%ED%95%A0%20%EC%88%98%20%EC%9E%88%EC%9D%84%EA%B9%8C%3F",
        encodedUserName: "-%EC%96%B4%EB%96%A4%EC%98%A4%ED%9B%84-",
      },
      {
        uniqueId: "6756419_14",
        title:
          "6월은 NEW월! CGV 이벤트, 6월 신규 회원, CJ ONE POINT 최대 50% 캐시백, CJ ONE 포인트, 회원 약관 동의, 통합회원 가입, 페이백",
        summary:
          "CGV 이벤트 CGV 이벤트 정보입니다. 6월은 NEW월 이벤트 CGV에서6월 신규 가입 회원 한정으로CJ ONE POINT를최대 50% 페이백 해주는이벤트를 진행 중입니다.   이벤트 상세 정보  기간은 6월 1일부터6월 30일까지이며신규 회원이최대 50% 페이백을받는 방법은 다음과 같습니다.  STEP 1 - 6월 CGV에신규 가입한다.※ 신규 가입 회원 정의..",
        userId: 3843451,
        userName: "롤리 폴리 토이",
        userImage:
          "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        categoryName: "영화",
        thumbnail:
          "https://k.kakaocdn.net/dn/UhrqB/btsHUoEzm5d/dbWREKCFs5ndtHH4RBvKs0/img.jpg",
        link: "https://roly-poly-toy.tistory.com/14",
        blogId: 6756419,
        blogTitle: "ROLY POLY TOY",
        likeCount: 13,
        commentCount: 4,
        firstReactionCreated: 1718080099000,
        published: "2024.06.11 13:28",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "6%EC%9B%94%EC%9D%80%20NEW%EC%9B%94%21%20CGV%20%EC%9D%B4%EB%B2%A4%ED%8A%B8%2C%206%EC%9B%94%20%EC%8B%A0%EA%B7%9C%20%ED%9A%8C%EC%9B%90%2C%20CJ%20ONE%20POINT%20%EC%B5%9C%EB%8C%80%2050%25%20%EC%BA%90%EC%8B%9C%EB%B0%B1%2C%20CJ%20ONE%20%ED%8F%AC%EC%9D%B8%ED%8A%B8%2C%20%ED%9A%8C%EC%9B%90%20%EC%95%BD%EA%B4%80%20%EB%8F%99%EC%9D%98%2C%20%ED%86%B5%ED%95%A9%ED%9A%8C%EC%9B%90%20%EA%B0%80%EC%9E%85%2C%20%ED%8E%98%EC%9D%B4%EB%B0%B1",
        encodedUserName:
          "%EB%A1%A4%EB%A6%AC%20%ED%8F%B4%EB%A6%AC%20%ED%86%A0%EC%9D%B4",
      },
      {
        uniqueId: "6406290_860",
        title:
          "에버랜드에서 경험하는 세계적 수준의 서커스, '레니의 컬러풀 드림', 가족과 함께 즐길 수 있는 최고의 선택",
        summary:
          "에버랜드는 지난 5월 초부터 시작한 새로운 서커스 공연 '레니의 컬러풀 드림'이 한 달여 만에 약 4만 명의 관람객을 끌어모았다고 밝혔다. 이는 에버랜드에서 진행된 실내 공연 중 가장 높은 만족도를 기록한 것으로, 관람객 대상 조사에서 평균 95점 이상의 높은 점수를 받았다.       '레니의 컬러풀 드림'은 티익스프레스, 사파리월드, 로스트밸리 등 에버..",
        userId: 6234843,
        userName: "봄꽃이랑 기쁨이랑 꽁냥꽁냥",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6406290/attach/355baabef63a44fb9a8958a3655520d8",
        categoryName: "공연·전시·축제",
        thumbnail:
          "https://k.kakaocdn.net/dn/cslOWy/btsHU9s2GuG/Kak7pzZAwyrqq3KL1KAPD0/img.jpg",
        link: "https://seuni80.tistory.com/860",
        blogId: 6406290,
        blogTitle: "다채로운 다둥맘의 세계",
        likeCount: 9,
        commentCount: 12,
        firstReactionCreated: 1718078323000,
        published: "2024.06.11 12:56",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%97%90%EB%B2%84%EB%9E%9C%EB%93%9C%EC%97%90%EC%84%9C%20%EA%B2%BD%ED%97%98%ED%95%98%EB%8A%94%20%EC%84%B8%EA%B3%84%EC%A0%81%20%EC%88%98%EC%A4%80%EC%9D%98%20%EC%84%9C%EC%BB%A4%EC%8A%A4%2C%20%27%EB%A0%88%EB%8B%88%EC%9D%98%20%EC%BB%AC%EB%9F%AC%ED%92%80%20%EB%93%9C%EB%A6%BC%27%2C%20%EA%B0%80%EC%A1%B1%EA%B3%BC%20%ED%95%A8%EA%BB%98%20%EC%A6%90%EA%B8%B8%20%EC%88%98%20%EC%9E%88%EB%8A%94%20%EC%B5%9C%EA%B3%A0%EC%9D%98%20%EC%84%A0%ED%83%9D",
        encodedUserName:
          "%EB%B4%84%EA%BD%83%EC%9D%B4%EB%9E%91%20%EA%B8%B0%EC%81%A8%EC%9D%B4%EB%9E%91%20%EA%BD%81%EB%83%A5%EA%BD%81%EB%83%A5",
      },
      {
        uniqueId: "5635119_486",
        title: "백패커2 백종원 요리예능 추천",
        summary:
          "백종원 요리 예능 추천 \uD83E\uDED5백패커2  ✸첫 방송              24년 5월 26일 ✸ 부작                 5부작 ✸ 등급                 15세 이상✸ 국가                 한국 ✸ 구분                 예능✸ 출연진              백종원, 안보현, 이수근, 허경환, 고경표✸ PD    ..",
        userId: 5607015,
        userName: "뿡뿡이로라",
        userImage:
          "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        categoryName: "TV",
        thumbnail:
          "https://k.kakaocdn.net/dn/bSWf0a/btsHU55kOJG/W29E8Wktmk7oYd8n3z3MSK/img.jpg",
        link: "https://pp-e.tistory.com/entry/백패커2-백종원-요리예능-추천",
        blogId: 5635119,
        blogTitle: "제주사는 뿡뿡이",
        likeCount: 11,
        commentCount: 7,
        firstReactionCreated: 1718077334000,
        published: "2024.06.11 12:41",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%B0%B1%ED%8C%A8%EC%BB%A42%20%EB%B0%B1%EC%A2%85%EC%9B%90%20%EC%9A%94%EB%A6%AC%EC%98%88%EB%8A%A5%20%EC%B6%94%EC%B2%9C",
        encodedUserName: "%EB%BF%A1%EB%BF%A1%EC%9D%B4%EB%A1%9C%EB%9D%BC",
      },
      {
        uniqueId: "3689059_1185",
        title:
          "[북미박스오피스 6월 2주차] 안 좋은 극장가 좋은 성적으로 등장하는 '나쁜 녀석들: 라이드 오어 다이'",
        summary:
          "2024년 6월 북미 영화순위23주 차 북미박스오피스6월 7일 ~ 6월 9일 [북미박스오피스 6월 1주 차] 신작의 힘이 빠진 북미 '가필드' 정상2024년 북미 영화순위22주 차 북미박스오피스6월 7일 ~ 6월 9일 [5월 4주차 북미박스오피스 21주차 영화순위] '퓨리오사: 매드맥스 사가' 많은 기대 속에 순위는2024년 북미 영화순위21주  북미박스오jyn2863.tistory.com ..",
        userId: 4231704,
        userName: "무비짱",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3689059/attach/b4a6a5c3c73c4a9aa739c21c983cb027",
        categoryName: "영화",
        thumbnail:
          "https://k.kakaocdn.net/dn/cwtGDv/btsHTTZf1ul/ysQccUQGlCMeFMXNt1Touk/img.jpg",
        link: "https://movie2863.tistory.com/1185",
        blogId: 3689059,
        blogTitle: "팝콘영화이야기",
        likeCount: 11,
        commentCount: 9,
        firstReactionCreated: 1718075101000,
        published: "2024.06.11 12:04",
        publishedAgo: "3시간 전",
        supportCount: 0,
        encodedTitle:
          "%5B%EB%B6%81%EB%AF%B8%EB%B0%95%EC%8A%A4%EC%98%A4%ED%94%BC%EC%8A%A4%206%EC%9B%94%202%EC%A3%BC%EC%B0%A8%5D%20%EC%95%88%20%EC%A2%8B%EC%9D%80%20%EA%B7%B9%EC%9E%A5%EA%B0%80%20%EC%A2%8B%EC%9D%80%20%EC%84%B1%EC%A0%81%EC%9C%BC%EB%A1%9C%20%EB%93%B1%EC%9E%A5%ED%95%98%EB%8A%94%20%27%EB%82%98%EC%81%9C%20%EB%85%80%EC%84%9D%EB%93%A4%3A%20%EB%9D%BC%EC%9D%B4%EB%93%9C%20%EC%98%A4%EC%96%B4%20%EB%8B%A4%EC%9D%B4%27",
        encodedUserName: "%EB%AC%B4%EB%B9%84%EC%A7%B1",
      },
      {
        uniqueId: "6078825_290",
        title: "교향곡 협주곡 관현악곡 실내악곡 차이... 도대체 뭐가 다를까?",
        summary:
          "알아두면 클래식 감상에 도움이 되는 클래식 잡학 사전 코너입니다. 이번에는 교향곡 협주곡 관현악곡 실내악곡이 어떠게 다른지 알아보도록 하겠습니다.  클래식을 듣다 보면 연주곡에 여러 형태가 많다는 것을 알게 됩니다. 기악곡과 성악곡 이런 것들은 알기 쉽지요. 하지만 교향곡, 관현악곡, 협주곡, 실내악곡 등은 어떻게 다른지 알쏭달쏭할 때가 있습니다. ..",
        userId: 5977753,
        userName: "다시채",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6078825/attach/d37a6eb70ce748ae859e398644afb270",
        categoryName: "음악",
        thumbnail:
          "https://k.kakaocdn.net/dn/dgngrn/btsHTDPXna3/eoh6f0cu4Rp7psTy4NUHTK/img.webp",
        link: "https://dasichae.tistory.com/290",
        blogId: 6078825,
        blogTitle: "함께 하는 클래식",
        likeCount: 10,
        commentCount: 12,
        firstReactionCreated: 1718074700000,
        published: "2024.06.11 11:51",
        publishedAgo: "3시간 전",
        supportCount: 0,
        encodedTitle:
          "%EA%B5%90%ED%96%A5%EA%B3%A1%20%ED%98%91%EC%A3%BC%EA%B3%A1%20%EA%B4%80%ED%98%84%EC%95%85%EA%B3%A1%20%EC%8B%A4%EB%82%B4%EC%95%85%EA%B3%A1%20%EC%B0%A8%EC%9D%B4...%20%EB%8F%84%EB%8C%80%EC%B2%B4%20%EB%AD%90%EA%B0%80%20%EB%8B%A4%EB%A5%BC%EA%B9%8C%3F",
        encodedUserName: "%EB%8B%A4%EC%8B%9C%EC%B1%84",
      },
      {
        uniqueId: "3707109_861",
        title: "인물비주얼이 완성ㅎ 스파이 러브스토리. 영화 '얼라이드'",
        summary:
          "1940년대 초반 배경 그리고 스파이 인물들깊은 사랑 주제의 긴장감 있는 스토리얼라이드(2017)_로버트 저메키스 영화는 2차 세계 대전 당시 프랑스령이었던 모로코 카사블랑카를 일단 배경으로, 1940년대 초반 나치 독일 하의 모습을 비춥니다. 그 안에 두 남녀, 맥스 바탄(브래드 피트)과 마리안 부세주르(마리옹 코티야르)가 있습니다. 이 둘이 다소간 이국적인 ..",
        userId: 4243932,
        userName: "문여는곰.",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3707109/attach/c9f488f48fc049b0aae06cdf8bb1c406",
        categoryName: "영화",
        thumbnail:
          "https://k.kakaocdn.net/dn/dCYu3e/btsHSzeNyQw/OZMmzKJtZIgnNFbOMQKrMk/img.jpg",
        link: "https://jyshine24.tistory.com/861",
        blogId: 3707109,
        blogTitle: "문여는곰 문화탐방",
        likeCount: 7,
        commentCount: 3,
        firstReactionCreated: 1718074294000,
        published: "2024.06.11 09:51",
        publishedAgo: "5시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%9D%B8%EB%AC%BC%EB%B9%84%EC%A3%BC%EC%96%BC%EC%9D%B4%20%EC%99%84%EC%84%B1%E3%85%8E%20%EC%8A%A4%ED%8C%8C%EC%9D%B4%20%EB%9F%AC%EB%B8%8C%EC%8A%A4%ED%86%A0%EB%A6%AC.%20%EC%98%81%ED%99%94%20%27%EC%96%BC%EB%9D%BC%EC%9D%B4%EB%93%9C%27",
        encodedUserName: "%EB%AC%B8%EC%97%AC%EB%8A%94%EA%B3%B0.",
      },
      {
        uniqueId: "6405688_413",
        title:
          "2024 춘천막국수닭갈비축제 일정 프로그램 라인업 트로트실버가요제 정보",
        summary:
          "춘천막국수닭갈비축제 춘천막국수닭갈비축제로 막 오세요! 꼭이요!춘천의 대표적인 축제인 춘천막국수닭갈비축제가 6월 18일부터 23일까지 레고랜드 코리아 리조트 주차장 일원에서 개최된다. 이번 축제는 18일 개막을 시작으로 멀티미디어 드론쇼, 인기가수 축하공연등 다양한 볼거리와 체험형 프로그램으로 춘천에서 즐기는 막국수, 닭갈비를 다양하게 선보인..",
        userId: 6234397,
        userName: "318d",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6405688/attach/8bfef293d268476890a002c4151e714d",
        categoryName: "공연·전시·축제",
        thumbnail:
          "https://k.kakaocdn.net/dn/cKLktL/btsHTasBThP/yVQAJbhF5Ei2tCBkTqJkAk/img.png",
        link: "https://318d.tistory.com/413",
        blogId: 6405688,
        blogTitle: "파라파라파라다이스",
        likeCount: 15,
        commentCount: 20,
        firstReactionCreated: 1718073819000,
        published: "2024.06.11 11:40",
        publishedAgo: "3시간 전",
        supportCount: 0,
        encodedTitle:
          "2024%20%EC%B6%98%EC%B2%9C%EB%A7%89%EA%B5%AD%EC%88%98%EB%8B%AD%EA%B0%88%EB%B9%84%EC%B6%95%EC%A0%9C%20%EC%9D%BC%EC%A0%95%20%ED%94%84%EB%A1%9C%EA%B7%B8%EB%9E%A8%20%EB%9D%BC%EC%9D%B8%EC%97%85%20%ED%8A%B8%EB%A1%9C%ED%8A%B8%EC%8B%A4%EB%B2%84%EA%B0%80%EC%9A%94%EC%A0%9C%20%EC%A0%95%EB%B3%B4",
        encodedUserName: "318d",
      },
      {
        uniqueId: "6216983_142",
        title:
          "중드 별을 따는 버들잎 : 류엽적성진 2024 로맨스 고장극 중국드라마 선결혼후연애 원작",
        summary:
          "최신 고장극 로맨스 중드 별을 따는 버들잎 : 류엽적성진 柳叶摘星辰 , My Wife's Double Life 사극 더쿠 로맨스 재미 어때 추천 원작 후기 결말 원작 보는곳 한글자막 등장인물 출연진2024년 신작 중국드라마 별을 따는 버들잎 류엽적성진에 대해 알아보도록하겠습니다. 출연진, 회차정보, 키워드, 원작정보 등을 알아보도록 하겠습니다.1. 별을 따는 버들잎 : 류엽..",
        userId: 5742289,
        userName: "띵동이애이미",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5803779/attach/8ce307b2f9ae4c269b3fef9e34b6fc05",
        categoryName: "TV",
        thumbnail:
          "https://k.kakaocdn.net/dn/u33wn/btsHU9Nj8xO/RWnoTvacrigMK9UbHGNKJK/img.webp",
        link: "https://tutle-papa.com/142",
        blogId: 6216983,
        blogTitle: "드라마 덕질 블로그 : 덕써니",
        likeCount: 11,
        commentCount: 4,
        firstReactionCreated: 1718070521000,
        published: "2024.06.11 10:47",
        publishedAgo: "4시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%A4%91%EB%93%9C%20%EB%B3%84%EC%9D%84%20%EB%94%B0%EB%8A%94%20%EB%B2%84%EB%93%A4%EC%9E%8E%20%3A%20%EB%A5%98%EC%97%BD%EC%A0%81%EC%84%B1%EC%A7%84%202024%20%EB%A1%9C%EB%A7%A8%EC%8A%A4%20%EA%B3%A0%EC%9E%A5%EA%B7%B9%20%EC%A4%91%EA%B5%AD%EB%93%9C%EB%9D%BC%EB%A7%88%20%EC%84%A0%EA%B2%B0%ED%98%BC%ED%9B%84%EC%97%B0%EC%95%A0%20%EC%9B%90%EC%9E%91",
        encodedUserName:
          "%EB%9D%B5%EB%8F%99%EC%9D%B4%EC%95%A0%EC%9D%B4%EB%AF%B8",
      },
    ],
    category: "culture",
    hasNext: true,
  },
};

export const dummyItemCulture2 = {
  "error": false,
  "data": {
    "lastPublished": 1718870884000,
    "list": [
      {
        "uniqueId": "2914757_608",
        "title": "호사카 유지 교수 - 신친일파 '반일 종족주의'의 거짓을 파헤친다",
        "summary": "이영훈 교수의 '반일 종족주의' 책 읽어보셨나요?일제강점기 때의 쌀과 토지 수탈, 위안부, 강제 징용 노동자, 독도, 일본의 과거 배상 문제 등을 서술한 내용입니다.한일관계는 전부 한국의 잘못이고 일본이 옳다고 하여 한국인으로서 불쾌했던 책이었다. ​책을 읽다 보면 그럴싸한 논리에 빠져들게 되는데 이영훈 교수는 일본에 유리한 증거만을 짜깁기해서 모..",
        "userId": 3761489,
        "userName": "푸른빛의선풍",
        "userImage": "https://tistory1.daumcdn.net/tistory/2914757/attach/0fa0b552edfa4479ba297c7747d3b1bb",
        "categoryName": "책",
        "thumbnail": "https://k.kakaocdn.net/dn/bKZBWq/btsH6SyebQW/hxVRRNwKHus2o6kpliGH8k/img.jpg",
        "link": "https://tatumakisenpu.tistory.com/608",
        "blogId": 2914757,
        "blogTitle": "돌개바람",
        "likeCount": 7,
        "commentCount": 5,
        "firstReactionCreated": 1718886452000,
        "published": "2024.06.20 21:17",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%ED%98%B8%EC%82%AC%EC%B9%B4%20%EC%9C%A0%EC%A7%80%20%EA%B5%90%EC%88%98%20-%20%EC%8B%A0%EC%B9%9C%EC%9D%BC%ED%8C%8C%20%27%EB%B0%98%EC%9D%BC%20%EC%A2%85%EC%A1%B1%EC%A3%BC%EC%9D%98%27%EC%9D%98%20%EA%B1%B0%EC%A7%93%EC%9D%84%20%ED%8C%8C%ED%97%A4%EC%B9%9C%EB%8B%A4",
        "encodedUserName": "%ED%91%B8%EB%A5%B8%EB%B9%9B%EC%9D%98%EC%84%A0%ED%92%8D"
      },
      {
        "uniqueId": "6228111_141",
        "title": "코치 성범죄 알고도 조치 없었다 남현희 제명 서울시펜싱협회 지도자자격박탈(?) 체육인 품위 훼손 남현희펜싱아카데미 코치 극단적 선택",
        "summary": "슬이랑입니다 남현희는 한때는 국민 영웅으로 굉장한 사랑을 받았던 국민펜싱 지도자 입니다. 그러나 전청조사건으로 인해 그녀 역시 똑같은 피해자로 모든 것을 내려놓는 모습을 보이기도 했습니다. 그렇지만, 전청조에게 속아서 미래를 약속했고, 그녀가 받은 수많은 선물들도 다 반납했다고 본인은 절대로 억울하다고 호소하는데도. 왜 서울시펜싱협회는 그녀의..",
        "userId": 6108452,
        "userName": "슬이랑",
        "userImage": "https://tistory1.daumcdn.net/tistory/6228111/attach/9d5631f3ee6e4fbeb15947dd0a9e09a6",
        "categoryName": "스타",
        "thumbnail": "https://k.kakaocdn.net/dn/nSeRJ/btsH5ZkXkNH/CqtWTzcjieuezkSoUjtuP1/img.png",
        "link": "https://tstoryjob.tistory.com/141",
        "blogId": 6228111,
        "blogTitle": "건강한 인생 건강한 마음",
        "likeCount": 24,
        "commentCount": 30,
        "firstReactionCreated": 1718885419000,
        "published": "2024.06.20 21:08",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%BD%94%EC%B9%98%20%EC%84%B1%EB%B2%94%EC%A3%84%20%EC%95%8C%EA%B3%A0%EB%8F%84%20%EC%A1%B0%EC%B9%98%20%EC%97%86%EC%97%88%EB%8B%A4%20%EB%82%A8%ED%98%84%ED%9D%AC%20%EC%A0%9C%EB%AA%85%20%EC%84%9C%EC%9A%B8%EC%8B%9C%ED%8E%9C%EC%8B%B1%ED%98%91%ED%9A%8C%20%EC%A7%80%EB%8F%84%EC%9E%90%EC%9E%90%EA%B2%A9%EB%B0%95%ED%83%88%28%3F%29%20%EC%B2%B4%EC%9C%A1%EC%9D%B8%20%ED%92%88%EC%9C%84%20%ED%9B%BC%EC%86%90%20%EB%82%A8%ED%98%84%ED%9D%AC%ED%8E%9C%EC%8B%B1%EC%95%84%EC%B9%B4%EB%8D%B0%EB%AF%B8%20%EC%BD%94%EC%B9%98%20%EA%B7%B9%EB%8B%A8%EC%A0%81%20%EC%84%A0%ED%83%9D",
        "encodedUserName": "%EC%8A%AC%EC%9D%B4%EB%9E%91"
      },
      {
        "uniqueId": "5320393_100",
        "title": "240617 아이돌 라디오",
        "summary": "",
        "userId": 224322,
        "userName": "Luire.",
        "userImage": "https://tistory1.daumcdn.net/tistory/5320393/attach/aa869a816d8a4a528514b4d6e9d67c1e",
        "categoryName": "스타",
        "thumbnail": "https://k.kakaocdn.net/dn/cGoRjs/btsH7nSoEZm/nnwE8p1qfJeGI0shNWYb6K/img.jpg",
        "link": "https://luire-xia.tistory.com/100",
        "blogId": 5320393,
        "blogTitle": "𝐘𝐨𝐮 𝐬𝐡𝐢𝐧𝐞 𝐟𝐨𝐫𝐞𝐯𝐞𝐫 ✨",
        "likeCount": 13,
        "commentCount": 0,
        "firstReactionCreated": 1718885101000,
        "published": "2024.06.20 20:58",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "240617%20%EC%95%84%EC%9D%B4%EB%8F%8C%20%EB%9D%BC%EB%94%94%EC%98%A4",
        "encodedUserName": "Luire."
      },
      {
        "uniqueId": "5599069_8004",
        "title": "장암(長巖) 이곤순(李坤淳)의 ＜유공무사＞",
        "summary": "_ 장암(長巖) 이곤순(李坤淳 1948  ~ , 보령 대천 출생) , 2005,  135×35cm, 보령박물관_장암서예관 유공무사(惟公無私) : 공은 사사로움이 없어 이기적이지 않다.. _ 장암(長巖) 이곤순(李坤淳 1948  ~ , 보령 대천 출생) 2024.02.04, 보령박물관_장암서예관, 이곤순의 세계'청허(淸虛)' ▼보시고 유익하셨다면 공감(♥) 눌러주세요",
        "userId": 5579890,
        "userName": "기리여원",
        "userImage": "https://tistory1.daumcdn.net/tistory/5599069/attach/19870c905acf40a7b6e1fae7e4f96ae6",
        "categoryName": "공연·전시·축제",
        "thumbnail": "https://k.kakaocdn.net/dn/Dl02f/btsH5uTd9yt/ySWKN86kbsbH5m7lgxyu01/img.png",
        "link": "https://99sangk.tistory.com/entry/장암長巖-이곤순李坤淳의-＜유공무사＞",
        "blogId": 5599069,
        "blogTitle": "기리여원",
        "likeCount": 19,
        "commentCount": 4,
        "firstReactionCreated": 1718884620000,
        "published": "2024.06.20 20:56",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%9E%A5%EC%95%94%28%E9%95%B7%E5%B7%96%29%20%EC%9D%B4%EA%B3%A4%EC%88%9C%28%E6%9D%8E%E5%9D%A4%E6%B7%B3%29%EC%9D%98%20%EF%BC%9C%EC%9C%A0%EA%B3%B5%EB%AC%B4%EC%82%AC%EF%BC%9E",
        "encodedUserName": "%EA%B8%B0%EB%A6%AC%EC%97%AC%EC%9B%90"
      },
      {
        "uniqueId": "6216983_146",
        "title": "달달한 드라마 : 나는 대놓고 신데렐라를 꿈꾼다 2024 로맨스 코미디 추천 후기 결말 원작 나대신꿈",
        "summary": "최신 현대물 한국드라마 더쿠 드라마 나는 대놓고 신데렐라를 꿈꾼다 나대신꿈 재미 어때 추천 후기 소설 원작 로맨스 결말 원작 등장인물 출연진 Dreaming of a Freaking Fairy Tale / 私は堂々とシンデレラを夢見る 我夢想成為灰姑娘 표예진 이준영 이현진 송지우 나이차 나이 2024년 신작 드라마 조폭인 내가 고등학생이 되었습니다에 대해 알아보도록 하겠습..",
        "userId": 5742289,
        "userName": "띵동이애이미",
        "userImage": "https://tistory1.daumcdn.net/tistory/5803779/attach/8ce307b2f9ae4c269b3fef9e34b6fc05",
        "categoryName": "TV",
        "thumbnail": "https://k.kakaocdn.net/dn/dvNtB1/btsH41pWerT/aTcFtVYKiEAdHnpKh69Bxk/img.webp",
        "link": "https://tutle-papa.com/146",
        "blogId": 6216983,
        "blogTitle": "드라마 덕질 블로그 : 덕써니",
        "likeCount": 11,
        "commentCount": 3,
        "firstReactionCreated": 1718882891000,
        "published": "2024.06.20 20:27",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%8B%AC%EB%8B%AC%ED%95%9C%20%EB%93%9C%EB%9D%BC%EB%A7%88%20%3A%20%EB%82%98%EB%8A%94%20%EB%8C%80%EB%86%93%EA%B3%A0%20%EC%8B%A0%EB%8D%B0%EB%A0%90%EB%9D%BC%EB%A5%BC%20%EA%BF%88%EA%BE%BC%EB%8B%A4%202024%20%EB%A1%9C%EB%A7%A8%EC%8A%A4%20%EC%BD%94%EB%AF%B8%EB%94%94%20%EC%B6%94%EC%B2%9C%20%ED%9B%84%EA%B8%B0%20%EA%B2%B0%EB%A7%90%20%EC%9B%90%EC%9E%91%20%EB%82%98%EB%8C%80%EC%8B%A0%EA%BF%88",
        "encodedUserName": "%EB%9D%B5%EB%8F%99%EC%9D%B4%EC%95%A0%EC%9D%B4%EB%AF%B8"
      },
      {
        "uniqueId": "6406290_890",
        "title": "칸 국제영화제 극찬, 베테랑2! 9월 개봉 확정, 황정민과 정해인의 최강 케미",
        "summary": "2024년, 한국 영화계의 기대작 '베테랑2'가 마침내 개봉을 확정 지었습니다. 제77회 칸 국제영화제 미드나잇 스크리닝 부문에 초청되며 전 세계의 주목을 받은 '베테랑2'는 나쁜 놈은 끝까지 잡는 베테랑 서도철 형사(황정민)의 활약과 그의 팀에 새롭게 합류한 박선우 형사(정해인)의 등장으로 더욱 강렬해진 액션과 스릴을 선사할 예정입니다.       칸 국제..",
        "userId": 6234843,
        "userName": "봄꽃이랑 기쁨이랑 꽁냥꽁냥",
        "userImage": "https://tistory1.daumcdn.net/tistory/6406290/attach/355baabef63a44fb9a8958a3655520d8",
        "categoryName": "영화",
        "thumbnail": "https://k.kakaocdn.net/dn/EgOJx/btsH5KOOVu5/kqZKKHXdOtE2y6vrSgJPRK/img.jpg",
        "link": "https://seuni80.tistory.com/890",
        "blogId": 6406290,
        "blogTitle": "다채로운 다둥맘의 세계",
        "likeCount": 13,
        "commentCount": 14,
        "firstReactionCreated": 1718882527000,
        "published": "2024.06.20 20:09",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%B9%B8%20%EA%B5%AD%EC%A0%9C%EC%98%81%ED%99%94%EC%A0%9C%20%EA%B7%B9%EC%B0%AC%2C%20%EB%B2%A0%ED%85%8C%EB%9E%912%21%209%EC%9B%94%20%EA%B0%9C%EB%B4%89%20%ED%99%95%EC%A0%95%2C%20%ED%99%A9%EC%A0%95%EB%AF%BC%EA%B3%BC%20%EC%A0%95%ED%95%B4%EC%9D%B8%EC%9D%98%20%EC%B5%9C%EA%B0%95%20%EC%BC%80%EB%AF%B8",
        "encodedUserName": "%EB%B4%84%EA%BD%83%EC%9D%B4%EB%9E%91%20%EA%B8%B0%EC%81%A8%EC%9D%B4%EB%9E%91%20%EA%BD%81%EB%83%A5%EA%BD%81%EB%83%A5"
      },
      {
        "uniqueId": "5732620_648",
        "title": "조지훈 시 병에게",
        "summary": "조지훈 시인님의 시 '병(病)에게'를 만납니다. 병을 통해 지난 삶과 현재의 삶을 성찰하게 하는 시입니다. 함께 읽으며 마음을 맑히는 독서목욕을 하십시다. 1. 조지훈 시 '병(病)에게' 읽기 병(病)에게 조지훈(1920~1968, 경북 영양) 어딜 가서 까맣게 소식을 끊고 지내다가도내가 오래 시달리던 일손을 떼고 마악 안도의 숨을 돌리려고 할 때면그때 자네는 어..",
        "userId": 5684802,
        "userName": "빗방울이네",
        "userImage": "https://tistory1.daumcdn.net/tistory/5732620/attach/6c2cfdcf37ee482fba9b9070ff1ef0a4",
        "categoryName": "책",
        "thumbnail": "https://k.kakaocdn.net/dn/buA07F/btsH7y0rjYG/AVhsK8s0xPakTKUt9a5HQ0/img.png",
        "link": "https://interestingtopicofconversation.tistory.com/entry/조지훈-시-병에게",
        "blogId": 5732620,
        "blogTitle": "독서목욕",
        "likeCount": 24,
        "commentCount": 26,
        "firstReactionCreated": 1718882333000,
        "published": "2024.06.20 20:18",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%A1%B0%EC%A7%80%ED%9B%88%20%EC%8B%9C%20%EB%B3%91%EC%97%90%EA%B2%8C",
        "encodedUserName": "%EB%B9%97%EB%B0%A9%EC%9A%B8%EC%9D%B4%EB%84%A4"
      },
      {
        "uniqueId": "5519874_535748",
        "title": "쇼팽 녹턴, 폴로네이즈 6번 ‘영웅’, 자장가, 환상 즉흥곡, 전주곡, 피아노소나타 3번 : 필리프 코파체프스키",
        "summary": "로그인만 하면 그냥 볼 수 있습니다프레데리크 쇼팽Frédéric Chopin(1810-1849)녹턴 4번Nocturne in F major, Op. 15 No. 1녹턴 2번Nocturne in E Flat Major, Op. 9 No. 2녹턴 20번Nocturne in C-sharp minor, Op. posth.폴로네이즈 6번 ‘영웅’Polonaise No. 6 in A-flat major (\"Heroic\"), Op. 53자장가Lullaby in D-flat major, Op. 57환상 즉흥곡Fantasy-Imp..",
        "userId": 5512320,
        "userName": "들꽃 호아저씨",
        "userImage": "https://tistory1.daumcdn.net/tistory/5519874/attach/51c015f9b3eb4fdba56d18e2377ef93c",
        "categoryName": "음악",
        "thumbnail": "https://k.kakaocdn.net/dn/NF9iN/btsH7jvewTt/uKgSfLaguXCFfmwa74ROAK/img.jpg",
        "link": "https://1917sr.tistory.com/entry/쇼팽-녹턴-폴로네이즈-6번-‘영웅’-자장가-환상-즉흥곡-전주곡-피아노소나타-3번-필리프-코파체프스키-49",
        "blogId": 5519874,
        "blogTitle": "들꽃",
        "likeCount": 13,
        "commentCount": 0,
        "firstReactionCreated": 1718876551000,
        "published": "2024.06.20 18:03",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%87%BC%ED%8C%BD%20%EB%85%B9%ED%84%B4%2C%20%ED%8F%B4%EB%A1%9C%EB%84%A4%EC%9D%B4%EC%A6%88%206%EB%B2%88%20%E2%80%98%EC%98%81%EC%9B%85%E2%80%99%2C%20%EC%9E%90%EC%9E%A5%EA%B0%80%2C%20%ED%99%98%EC%83%81%20%EC%A6%89%ED%9D%A5%EA%B3%A1%2C%20%EC%A0%84%EC%A3%BC%EA%B3%A1%2C%20%ED%94%BC%EC%95%84%EB%85%B8%EC%86%8C%EB%82%98%ED%83%80%203%EB%B2%88%20%3A%20%ED%95%84%EB%A6%AC%ED%94%84%20%EC%BD%94%ED%8C%8C%EC%B2%B4%ED%94%84%EC%8A%A4%ED%82%A4",
        "encodedUserName": "%EB%93%A4%EA%BD%83%20%ED%98%B8%EC%95%84%EC%A0%80%EC%94%A8"
      },
      {
        "uniqueId": "5572828_2004",
        "title": "변하는 것과 변하지 않는 것",
        "summary": "'변하는 것과 변하지 않는 것'을 읽고 정리한 내용을 소개합니다.이 책을 선택한 이유인문학적 마케팅은 어떤 방식인지 알고 싶어서 이 책을 읽게 되었습니다.책 소개마케팅의 기본원칙 현상보다 본질마케팅이란 무엇인가? 마케팅은 경영활동의 일부입니다. 경영은 재무 회계, 생산 운영, 인사조직, 경영전략 등 다양한 파트로 나누어져 있습니다. 학문적으로 또는 ..",
        "userId": 5557808,
        "userName": "JadeWolveS",
        "userImage": "https://tistory1.daumcdn.net/tistory/5572828/attach/ce371994a5c5423c8cddef0d0511ed05",
        "categoryName": "책",
        "thumbnail": "https://k.kakaocdn.net/dn/cGHCgI/btsH62tWcWs/DZKDaBDKZZBIKC5kXRNxlk/img.jpg",
        "link": "https://jadewolves.tistory.com/entry/4",
        "blogId": 5572828,
        "blogTitle": "청랑",
        "likeCount": 22,
        "commentCount": 6,
        "firstReactionCreated": 1718874117000,
        "published": "2024.06.20 18:00",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%B3%80%ED%95%98%EB%8A%94%20%EA%B2%83%EA%B3%BC%20%EB%B3%80%ED%95%98%EC%A7%80%20%EC%95%8A%EB%8A%94%20%EA%B2%83",
        "encodedUserName": "JadeWolveS"
      },
      {
        "uniqueId": "7034247_68",
        "title": "매일 글쓰기 두 달 후기::튜브처럼 떠오를 당신에게",
        "summary": "지난번 한 달 후기에서 두 달 후, 100일 후기를 이야기하지 않았던가? [일상기록] - [에세이] 글쓰기 도전 30일 후기: 꾸준함의 결과 [에세이] 글쓰기 도전 30일 후기: 꾸준함의 결과여러분!!!저 오늘로 글쓰기 도전 30일이 되었어요!! 쓰고 보니 부끄럽다. 그래도 일단 30일을 완수(?)한 나에게 박수를 보낸다. 짝짝짝! 무엇을 꾸준히 실천해 본 ..",
        "userId": 6650801,
        "userName": "그로우자몽",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "책",
        "thumbnail": "https://k.kakaocdn.net/dn/b9a3Of/btsH2CJkqYn/n74Sakc0kGPTP9YLuo0RFK/img.png",
        "link": "https://jamong-grow.tistory.com/68",
        "blogId": 7034247,
        "blogTitle": "매일의 힘",
        "likeCount": 19,
        "commentCount": 6,
        "firstReactionCreated": 1718873410000,
        "published": "2024.06.20 18:00",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%A7%A4%EC%9D%BC%20%EA%B8%80%EC%93%B0%EA%B8%B0%20%EB%91%90%20%EB%8B%AC%20%ED%9B%84%EA%B8%B0%3A%3A%ED%8A%9C%EB%B8%8C%EC%B2%98%EB%9F%BC%20%EB%96%A0%EC%98%A4%EB%A5%BC%20%EB%8B%B9%EC%8B%A0%EC%97%90%EA%B2%8C",
        "encodedUserName": "%EA%B7%B8%EB%A1%9C%EC%9A%B0%EC%9E%90%EB%AA%BD"
      },
      {
        "uniqueId": "4647542_946",
        "title": "‘시그널2’, 대본 나왔다…스포 내용 보니",
        "summary": "배우 이제훈이 드라마 ‘시그널2’의 대본을 봤다고 알리며, 자신감을 드러냈다. https://im.newspic.kr/vQkqBlB ‘시그널2’, 대본 나왔다…스포 내용 보니[TV리포트=한아름 기자] 배우 이제훈이 드라마 ‘시그널2’의 대본을 봤다고 알리며, 자신감을 드러냈다. 20일, 이제훈은 영화 ‘탈주’에 관한 언론 인터뷰를 진행했다. 인터뷰에서im.newspic.kr",
        "userId": 4833775,
        "userName": "띵스띵스",
        "userImage": "https://tistory1.daumcdn.net/tistory/4647542/attach/827104db80774607ab55296eff15ac46",
        "categoryName": "TV",
        "thumbnail": "https://k.kakaocdn.net/dn/cfLIpQ/btsH646mz4t/MevvLMLckdBhksWnOPAtMK/img.jpg",
        "link": "https://ddingstory.tistory.com/entry/‘시그널2’-대본-나왔다…스포-내용-보니",
        "blogId": 4647542,
        "blogTitle": "오늘의 이슈 / 정보",
        "likeCount": 45,
        "commentCount": 26,
        "firstReactionCreated": 1718871513000,
        "published": "2024.06.20 17:18",
        "publishedAgo": "5시간 전",
        "supportCount": 0,
        "encodedTitle": "%E2%80%98%EC%8B%9C%EA%B7%B8%EB%84%902%E2%80%99%2C%20%EB%8C%80%EB%B3%B8%20%EB%82%98%EC%99%94%EB%8B%A4%E2%80%A6%EC%8A%A4%ED%8F%AC%20%EB%82%B4%EC%9A%A9%20%EB%B3%B4%EB%8B%88",
        "encodedUserName": "%EB%9D%B5%EC%8A%A4%EB%9D%B5%EC%8A%A4"
      },
      {
        "uniqueId": "5186542_356",
        "title": "올여름 주목해 볼 만한 청량한 매력의 신예 싱어송라이터 'LORA(로라)'🌊",
        "summary": "안녕하세요. 손익분기점.입니다. 걷기만 해도 땀이 흐르는 무더운 6월의 여름 더위가 기승을 부리고 있는 요즘입니다. 더위를 이겨내기 위해 사람들은 청량한 음악과 함께 시원한 바닷속으로 여행을 떠나기도 합니다. 오늘 소개할 아티스트는 청량한 사운드가 인상적인 올여름 가장 주목해 볼 만한 청량한 매력의 신예 싱어송라이터 'LORA(로라)'입니다. 지금 바로 ..",
        "userId": 5255009,
        "userName": "손익분기점.",
        "userImage": "https://tistory1.daumcdn.net/tistory/5186542/attach/60bac5a716ee46f7bdb14fe6e416eb67",
        "categoryName": "음악",
        "thumbnail": "https://k.kakaocdn.net/dn/bkqK2D/btsH6uj6thB/dmbolV86Y5FIxRMOMlh5QK/img.jpg",
        "link": "https://breakevenpoint.tistory.com/356",
        "blogId": 5186542,
        "blogTitle": "멜론 파워DJ/ 뮤직에디터 손익분기점.",
        "likeCount": 16,
        "commentCount": 8,
        "firstReactionCreated": 1718870884000,
        "published": "2024.06.20 17:49",
        "publishedAgo": "4시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%98%AC%EC%97%AC%EB%A6%84%20%EC%A3%BC%EB%AA%A9%ED%95%B4%20%EB%B3%BC%20%EB%A7%8C%ED%95%9C%20%EC%B2%AD%EB%9F%89%ED%95%9C%20%EB%A7%A4%EB%A0%A5%EC%9D%98%20%EC%8B%A0%EC%98%88%20%EC%8B%B1%EC%96%B4%EC%86%A1%EB%9D%BC%EC%9D%B4%ED%84%B0%20%27LORA%28%EB%A1%9C%EB%9D%BC%29%27%F0%9F%8C%8A",
        "encodedUserName": "%EC%86%90%EC%9D%B5%EB%B6%84%EA%B8%B0%EC%A0%90."
      }
    ],
    "category": "culture",
    "hasNext": true
  }
}